import React from "react";

interface PendingSignaturesListSkeletonProps {
  count: number;
}

export default function PendingSignaturesListSkeleton({
  count,
}: PendingSignaturesListSkeletonProps) {
  const placeholderCount = Math.max(1, count);

  return (
    <div className="flex flex-col gap-3" aria-busy="true" aria-live="polite">
      <span className="sr-only">Carregando contratos</span>
      {Array.from({ length: placeholderCount }, (_, index) => (
        <div
          key={index}
          className="flex w-full flex-col gap-4 rounded-2xl border border-white/[0.08] bg-[#1c2128] p-4 sm:flex-row sm:items-start sm:justify-between"
        >
          <div className="min-w-0 flex-1 space-y-3">
            <div className="flex flex-wrap items-center gap-2">
              <div className="h-5 w-20 animate-pulse rounded-full bg-white/[0.08]" />
              <div className="h-3 w-40 max-w-full animate-pulse rounded-full bg-white/[0.06]" />
            </div>
            <div className="space-y-2">
              <div className="h-4 w-3/4 max-w-full animate-pulse rounded-full bg-white/[0.08]" />
              <div className="h-3 w-1/2 max-w-full animate-pulse rounded-full bg-white/[0.06]" />
            </div>
            <div className="h-3 w-44 max-w-full animate-pulse rounded-full bg-white/[0.06]" />
          </div>
          <div className="flex shrink-0 flex-col gap-2 sm:items-end">
            <div className="h-9 w-32 animate-pulse rounded-full bg-white/[0.08]" />
            <div className="h-9 w-36 animate-pulse rounded-full bg-white/[0.06]" />
          </div>
        </div>
      ))}
    </div>
  );
}
